import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=cbbaed2e&scoped=true&"
import script from "./CustomerInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomerInfo.vue?vue&type=style&index=1&id=cbbaed2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbaed2e",
  null
  
)

export default component.exports